import { render, staticRenderFns } from "./inspect.vue?vue&type=template&id=779c5906&scoped=true&"
import script from "./inspect.vue?vue&type=script&lang=js&"
export * from "./inspect.vue?vue&type=script&lang=js&"
import style0 from "./inspect.vue?vue&type=style&index=0&id=779c5906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c5906",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSelect,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779c5906')) {
      api.createRecord('779c5906', component.options)
    } else {
      api.reload('779c5906', component.options)
    }
    module.hot.accept("./inspect.vue?vue&type=template&id=779c5906&scoped=true&", function () {
      api.rerender('779c5906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/inspect.vue"
export default component.exports